var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { Col } from "reactstrap";
import Title from "../../components/Title";
import { COLOR } from "../../theme/constants";
var mapBg = {
  grey: COLOR.lightGrey,
  white: COLOR.white,
  green: COLOR.brandGreen
};
var mapIconBg = {
  green: COLOR.brandGreen,
  white: COLOR.white,
  orange: COLOR.brandOrange
};
export var InsuranceScopeWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n"], ["\n  background-color: ", ";\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n"])), function (_a) {
  var _b = _a.bg,
      bg = _b === void 0 ? "grey" : _b;
  return mapBg[bg];
});
export var Col1 = styled(Col)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
export var IconLargeWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  display: none;\n\n  &::before {\n    content: \"\";\n    display: block;\n    padding-top: 100%;\n  }\n\n  @media (min-width: 576px) {\n    display: initial;\n  }\n"], ["\n  width: 100%;\n  position: relative;\n  display: none;\n\n  &::before {\n    content: \"\";\n    display: block;\n    padding-top: 100%;\n  }\n\n  @media (min-width: 576px) {\n    display: initial;\n  }\n"])));
export var IconLargeBg = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 20%;\n\n  svg {\n    color: ", ";\n    fill: ", ";\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 20%;\n\n  svg {\n    color: ", ";\n    fill: ", ";\n  }\n"])), function (_a) {
  var _b = _a.iconBg,
      iconBg = _b === void 0 ? "green" : _b;
  return mapIconBg[iconBg];
}, function (_a) {
  var iconBg = _a.iconBg;
  return iconBg === "white" ? COLOR.brandOrange : COLOR.white;
}, function (_a) {
  var iconBg = _a.iconBg;
  return iconBg === "white" ? COLOR.brandOrange : COLOR.white;
}, function (_a) {
  var iconBg = _a.iconBg;
  return iconBg === "white" ? COLOR.brandOrange : COLOR.white;
});
export var Col2 = styled(Col)(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
export var Header = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
export var IconSmallWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50%;\n  width: 74px;\n  height: 74px;\n  padding: 16px;\n  margin-right: 1rem;\n  flex-shrink: 0;\n\n  svg {\n    color: ", ";\n    fill: ", ";\n  }\n\n  @media (min-width: 576px) {\n    display: none;\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50%;\n  width: 74px;\n  height: 74px;\n  padding: 16px;\n  margin-right: 1rem;\n  flex-shrink: 0;\n\n  svg {\n    color: ", ";\n    fill: ", ";\n  }\n\n  @media (min-width: 576px) {\n    display: none;\n  }\n"])), function (_a) {
  var _b = _a.iconBg,
      iconBg = _b === void 0 ? "green" : _b;
  return mapIconBg[iconBg];
}, function (_a) {
  var iconBg = _a.iconBg;
  return iconBg === "white" ? COLOR.brandOrange : COLOR.white;
}, function (_a) {
  var iconBg = _a.iconBg;
  return iconBg === "white" ? COLOR.brandOrange : COLOR.white;
}, function (_a) {
  var iconBg = _a.iconBg;
  return iconBg === "white" ? COLOR.brandOrange : COLOR.white;
});
export var StyledTitle = styled(Title)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  padding-top: 0.3rem;\n  color: ", ";\n  word-break: break-word;\n"], ["\n  padding-top: 0.3rem;\n  color: ", ";\n  word-break: break-word;\n"])), function (_a) {
  var _b = _a.bg,
      bg = _b === void 0 ? "grey" : _b;
  return bg === "green" ? "white" : "black";
});
export var Description = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-top: 2rem;\n  color: ", ";\n"], ["\n  margin-top: 2rem;\n  color: ", ";\n"])), function (_a) {
  var _b = _a.bg,
      bg = _b === void 0 ? "grey" : _b;
  return bg === "green" ? "white" : "black";
});
export var List = styled.ul(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  padding-left: 0;\n  margin-top: 2rem;\n  color: ", ";\n"], ["\n  padding-left: 0;\n  margin-top: 2rem;\n  color: ", ";\n"])), function (_a) {
  var _b = _a.bg,
      bg = _b === void 0 ? "grey" : _b;
  return bg === "green" ? "white" : "black";
});
export var ListItem = styled.li(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 1rem;\n  align-items: baseline;\n"], ["\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 1rem;\n  align-items: baseline;\n"])));
export var TickCircleIconWrapper = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  margin-right: 0.8rem;\n"], ["\n  margin-right: 0.8rem;\n"])));
export var ListItemText = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  font-size: 0.8125rem;\n  line-height: 1.25rem;\n  letter-spacing: 0.09px;\n  color: ", ";\n"], ["\n  font-size: 0.8125rem;\n  line-height: 1.25rem;\n  letter-spacing: 0.09px;\n  color: ", ";\n"])), function (_a) {
  var _b = _a.bg,
      bg = _b === void 0 ? "grey" : _b;
  return bg === "green" ? "white" : COLOR.darkGreen;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;